var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownchevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.152 4.40963L8 11.5616L0.848 4.40963C0.752 4.31363 0.634667 4.26562 0.496 4.26562C0.357333 4.26562 0.24 4.31363 0.144 4.40963C0.048 4.50563 0 4.62296 0 4.76163C0 4.90029 0.048 5.01763 0.144 5.11363L8 12.9696L15.856 5.11363C15.952 5.01763 16 4.90029 16 4.76163C16 4.62296 15.952 4.50563 15.856 4.40963C15.76 4.31363 15.6427 4.26562 15.504 4.26562C15.3653 4.26562 15.248 4.31363 15.152 4.40963Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownchevron);
export default __webpack_public_path__ + "static/media/downchevron.520e551d12e8840422b1490b8ef29f74.svg";
export { ForwardRef as ReactComponent };